import type { User } from '@/types';

// Mock data
export const mockUsers: User[] = [
    {
        id: "1",
        firstName: "Jordan",
        lastName: "Stevenson",
        name: "Jordan Stevenson",
        email: "jordan@example.com",
        role: "Admin",
        status: "Active",
        avatar: "/avatars/avatar-1.png",
        access: ["MijnPS", "DataEntry"],
        createdOn: "2024-01-01",
        lastActivity: "2024-01-01",
        locationActivity: "MijnPS",
        twoFactorEnabled: true
    },
    {
        id: "2",
        firstName: "Robert",
        lastName: "Crawford",
        name: "Robert Crawford",
        email: "robert@example.com",
        role: "Manager",
        status: "Pending",
        avatar: "/avatars/avatar-2.png",
        access: ["MijnPS", "DataEntry"],
        createdOn: "2024-01-01",
        lastActivity: "2024-01-01",
        locationActivity: "MijnPS",
        twoFactorEnabled: false
    },
    {
        id: "3",
        firstName: "Lydia",
        lastName: "Reese",
        name: "Lydia Reese",
        email: "lydia@example.com",
        role: "User",
        status: "Active",
        avatar: "/avatars/avatar-3.png",
        access: ["MijnPS", "DataEntry"],
        createdOn: "2024-01-01",
        lastActivity: "2024-01-01",
        locationActivity: "DataEntry",
        twoFactorEnabled: true
    },
    {
        id: "4",
        firstName: "Richard",
        lastName: "Wilson",
        name: "Richard Wilson",
        email: "richard@example.com",
        role: "User",
        status: "Inactive",
        avatar: "/avatars/avatar-4.png",
        access: ["MijnPS"],
        createdOn: "2024-01-01",
        lastActivity: "2024-01-01",
        locationActivity: "MijnPS",
        twoFactorEnabled: false
    },
    {
        id: "5",
        firstName: "Olivia",
        lastName: "Sanders",
        name: "Olivia Sanders",
        email: "olivia@example.com",
        role: "User",
        status: "Inactive",
        avatar: "/avatars/avatar-5.png",
        access: ["MijnPS"],
        createdOn: "2024-01-01",
        lastActivity: "2024-01-01",
        locationActivity: "MijnPS",
        twoFactorEnabled: false
    },
    {
        id: "6",
        firstName: "Mark",
        lastName: "Williams",
        name: "Mark Williams",
        email: "mark@example.com",
        role: "Admin",
        status: "Active",
        avatar: "/avatars/avatar-6.png",
        access: ["DataEntry"],
        createdOn: "2024-01-01",
        lastActivity: "2024-01-01",
        locationActivity: "DataEntry",
        twoFactorEnabled: true
    },
    {
        id: "7",
        firstName: "Sarah",
        lastName: "Chen",
        name: "Sarah Chen",
        email: "sarah@example.com",
        role: "Manager",
        status: "Active",
        avatar: "/avatars/avatar-7.png",
        access: ["MijnPS", "DataEntry"],
        createdOn: "2024-01-01",
        lastActivity: "2024-01-01",
        locationActivity: "DataEntry",
        twoFactorEnabled: true
    },
];

// API Service structure
export class UserService {
    private static instance: UserService;
    private users: User[] = mockUsers;

    private constructor() {}

    public static getInstance(): UserService {
        if (!UserService.instance) {
            UserService.instance = new UserService();
        }
        return UserService.instance;
    }

    // Get all users
    async getUsers(): Promise<User[]> {
        // TODO: Replace with actual API call
        return this.users;
    }

    // Get user by ID
    async getUserById(id: string): Promise<User | undefined> {
        // TODO: Replace with actual API call
        return this.users.find(user => user.id === id);
    }

    // Create new user
    async createUser(user: Omit<User, 'id'>): Promise<User> {
        // TODO: Replace with actual API call
        const newUser = {
            ...user,
            id: String(this.users.length + 1)
        };
        this.users.push(newUser);
        return newUser;
    }

    // Update user
    async updateUser(id: string, user: Partial<User>): Promise<User | undefined> {
        // TODO: Replace with actual API call
        const index = this.users.findIndex(u => u.id === id);
        if (index === -1) return undefined;
        
        this.users[index] = { ...this.users[index], ...user };
        return this.users[index];
    }

    // Delete user
    async deleteUser(id: string): Promise<boolean> {
        // TODO: Replace with actual API call
        const index = this.users.findIndex(u => u.id === id);
        if (index === -1) return false;
        
        this.users.splice(index, 1);
        return true;
    }

    // Delete multiple users
    async deleteUsers(ids: string[]): Promise<boolean> {
        // TODO: Replace with actual API call
        const initialLength = this.users.length;
        this.users = this.users.filter(user => !ids.includes(user.id));
        return this.users.length !== initialLength;
    }
} 